/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserWorkflowStep = {
  properties: {
    status: {
      type: 'UserWorkflowStepStatus',
      isRequired: true,
    },
    step: {
      type: 'WorkflowStep',
      isRequired: true,
    },
  },
} as const;
